export interface ILogger {
    debug(text: any): void;
    info(text: any): void;
    warn(text: any): void;
    error(text: any, exception: any): void;
}

class Logger implements ILogger {
    debug = (text: any) => {
        console.debug(text);
    };

    info = (text: any) => {
        console.info(text);
    };

    warn = (text: any) => {
        console.warn(text);
    };

    error = (text: any, exception: any) => {
        console.error(text, exception);
    };
}

const logger: ILogger = new Logger();
export default logger;
